import React, { useState } from "react";
import "./news.css";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import { Link } from "react-router-dom";

import { useRef } from "react";

import { useLocation } from "react-router-dom";

import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp, formatDaysAgo } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";


const data = [
  {
    title: "Mumbai Metro Line 3: Route map, stations list and latest...",
    date: "February 25, 2025",
  },
  {
    title: "Home loan interest rates in 2025: Compare rates from top...",
    date: "February 23, 2025",
  },
  {
    title: "Is Faridabad the next Gurgaon? Infrastructure and location...",
    date: "February 21, 2025",
  },
  {
    title: "RERA registration: How to check RERA number of any project...",
    date: "February 20, 2025",
  },
  {
    title: "Save 72% on premiums when you choose online home loan...",
    date: "February 18, 2025",
  },
];

export default function NewsList() {
  const navigate = useNavigate();
  const [newsData, setnewsData] = useState([]);
  const [heronewsData, setheronewsData] = useState(null);
  const [loader, setLoader] = useState(true);

  const [categoryData, setcategoryData] = useState([
    {
      id: 0,
      name: "All",
      colorCode: "#000000",
    },

    {
      id: 1,
      name: "Property Trends",
      colorCode: "#000000",
    },
    {
      id: 2,
      name: "Home Loans",
      colorCode: "#000000",
    },
    {
      id: 3,
      name: "Buying Guide",
      colorCode: "#000000",
    },
    {
      id: 4,
      name: "Rent",
      colorCode: "#000000",
    },
    {
      id: 5,
      name: "City Transport",
      colorCode: "#000000",
    },
    {
      id: 6,
      name: "Legal & Tax",
      colorCode: "#000000",
    },
    {
      id: 7,
      name: "Home Decor",
      colorCode: "#000000",
    },
    {
      id: 8,
      name: "NRI Corner",
      colorCode: "#000000",
    },
  ]);

  const [selecetedCategory, setselecetedCategory] = useState({
    id: 0,
    name: "All",
    colorCode: "#000000",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getNews(selecetedCategory);
  }, [selecetedCategory]);

  const getNews = (category) => {
const filter = category?.id != 0 ? `{'ArticleTypeID':{\$eq:${category?.id}}}` : "{}";

    getRecords(429, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setLoader(false);
          setnewsData(data?.response?.records || []);
          setheronewsData(data?.response?.records[0] || null);
        } else {
          setnewsData([]);
          setheronewsData(null);
          setLoader(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoader(false);
      }
    });
  };

  return (
    <div className="page-wrapper news">
      <Header />
      <section style={{ background: "#fff", paddingTop: 100 }}>
        <div className="container">
          <div className="row">
            {/* Breadcrumb */}
            <div className="breadcrumb">
              Home &nbsp;&gt;&nbsp; News & Articles
            </div>

            {/* Header */}
            <h1 className="title">Real Estate News & Insights</h1>
            <p className="desc">
              Stay updated with the latest property trends, home loan rates,
              legal updates and expert advice.
            </p>

            {/* Tabs */}
            <div className="tabs">
              {categoryData?.map((t, i) => (
                <span onClick={()=>setselecetedCategory(t)}
                  key={i}
                  className={
                    t.id === selecetedCategory?.id ? "tab active" : "tab"
                  }
                >
                  {t.name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="property-wrap ptb-50">
        <div className="container">
          {/* Hero */}

          {heronewsData != null && (
            <div className="hero">
              <img src={heronewsData?.Images} />
              <div className="overlay">
                <div>
                  <div className="badge">{heronewsData?.ArticleType}</div>
                  <h2>{heronewsData?.ArticleTitle}</h2>
                  <p
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {heronewsData?.ArticleContent}
                  </p>
                  <div className="author" style={{ display: "flex" }}>
                    <div style={{ display: "flex", marginRight: 10 }}>
                      <div className="iconns">
                        <i
                          class="ri-user-line text-gray-500 text-xs"
                          style={{ color: "#666" }}
                        ></i>
                      </div>{" "}
                      {heronewsData?.ArticleAuthor}
                    </div>{" "}
                    • {formatDaysAgo(heronewsData?.cDt?.split(" ")[0])}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Layout */}
          <div className="grid">
            {/* LEFT */}
            <div className="left">
              {newsData?.map((c, i) => (
                <Link to={`/news-details?id=${c?.ArticleID}`}>
                  <div className="card" key={i}>
                    <img src={c?.Images} />
                    <div className="rightdetails">
                      <div className="small">
                        {c?.ArticleType}
                        {/* • <span className="time">{c.time}</span> */}
                      </div>
                      <h3>{c?.ArticleTitle}</h3>
                      <small
                        style={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {c?.ArticleContent}
                      </small>
                      <p className="meta">
                        <span>
                          <div style={{ display: "flex", marginRight: 10 }}>
                            <div className="iconns">
                              <i class="ri-user-line text-gray-500 text-xs"></i>
                            </div>{" "}
                            {c?.ArticleAuthor}
                          </div>{" "}
                        </span>{" "}
                        • {formatDaysAgo(c?.cDt?.split(" ")[0])}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}

              {/* <button className="load">Load More Articles</button> */}
            </div>

            {/* RIGHT */}
            <div className="right">
              <div className="box">
                <h4>
                  <i
                    className="ri-fire-fill text-orange-500"
                    style={{ color: "#f97316" }}
                  ></i>{" "}
                  Trending Topics
                </h4>
                <ul >
                  {newsData
                    ?.filter((c) => c?.TrendingID === 1)
                    ?.map((data, i) => {
                      return <li onClick={()=>{navigate(`/news-details?id=${data?.ArticleID}`)}} >{data?.ArticleTitle}</li>;
                    })}
                </ul>
              </div>

              <div className="box">
                <div className="popular-card">
                  <div className="popular-header">
                    <span className="star">★</span>
                    <h3>Most Popular</h3>
                  </div>

                  <div className="popular-list">
                    {newsData
                      ?.filter((c) => c?.MostPopularID === 1)
                      .map((item, index) => (
                        <div onClick={()=>{navigate(`/news-details?id=${item?.ArticleID}`)}} className="popular-item" key={index}>
                          <div className="number">{index + 1}</div>

                          <div className="content">
                            <p className="title">{item.ArticleTitle}</p>
                            <span className="date">
                              {formatDaysAgo(item?.cDt?.split(" ")[0])}
                            </span>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="subscribe">
                <div className="iconnss">
                  <i class="ri-mail-line text-2xl"></i>
                </div>
                <h4>Stay Updated</h4>
                <p>
                  Get the latest real estate news and insights delivered to your
                  inbox.
                </p>
                <input placeholder="Enter your email" />
                <button>Subscribe Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

const cards = [
  {
    title: "Home loan interest rates in 2025: Compare rates from top banks",
    tag: "Home Loans",
    time: "6 min read",
    author: "Rahul Mehta",
    date: "February 23, 2025",
    img: "https://images.unsplash.com/photo-1560520031-3a4dc4e9de0c",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title:
      "Is Faridabad the next Gurgaon? Infrastructure and location advantages",
    tag: "Property Trends",
    time: "7 min read",
    author: "Sandeep Nayak",
    date: "February 21, 2025",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title: "RERA registration: How to check RERA number of any project online",
    tag: "Legal & Tax",
    time: "5 min read",
    author: "Anita Desai",
    date: "February 20, 2025",
    img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title: "Save 72% on premiums when you choose online home loan insurance",
    tag: "Home Loans",
    time: "6 min read",
    author: "Vivek Jain",
    date: "February 18, 2025",
    img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
  {
    title:
      "Top 10 Vastu tips for your new home: Direction, placement and remedies",
    tag: "Home Decor",
    time: "9 min read",
    author: "Meera Kapoor",
    date: "February 17, 2025",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511",
    description:
      "Home loan interest rates have seen a slight dip in early 2025. With the RBI holding repo rates steady, several banks have revised their lending rates downward.",
  },
];
